import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionTitle from '@/components/base/SectionTitle';

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState<'all' | 'ongoing' | 'completed'>('all');

  const filtered = comics.filter((c) => {
    if (activeTab === 'ongoing') return c.status === '连载中';
    if (activeTab === 'completed') return c.status === '已完结';
    return true;
  });

  const tabs = [
    { key: 'all' as const, label: '全部' },
    { key: 'ongoing' as const, label: '连载中' },
    { key: 'completed' as const, label: '已完结' },
  ];

  return (
    <section id="latest" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <SectionTitle
            label="/ 最新更新"
            title="新鲜出炉 · 追更不停歇"
            align="left"
          />
          <div className="inline-flex bg-background-100 rounded-full p-1 mt-4 md:mt-0">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {filtered.map((comic) => (
            <ComicCard
              key={comic.slug}
              slug={comic.slug}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              rating={comic.rating}
              status={comic.status}
              latestChapter={comic.chapters[0]?.number}
              variant="compact"
            />
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-colors text-sm whitespace-nowrap cursor-pointer"
          >
            浏览全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}